import React, { useEffect, useRef, useState } from "react";
import ListItem from "../../Tools/ListItem";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import FirstForm from "./FirstForm";
import SecondForm from "./SecondForm";
import { fromDetail } from "../../../Reducer/formSlice";
import { toast } from "react-toastify";
import { getAdFiltersList1, getModels } from "../../../Reducer/api";
import { bannerBuy } from "../../../utils/paths";
import {
  getAllFiltersData,
  getAllFiltersData1,
  getSelectedFilters,
} from "../../../utils/constants";
import i18n from "../../../i18n";

export default function BannerSection({ carTypes, page, filters }) {
  const { t } = useTranslation();
  const detail = useSelector((state) => state.fromsdata.fromsdata);
  const loading = useSelector((state) => state.fromsdata.loading);
  const error = useSelector((state) => state.fromsdata.error);
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState("used");
  const [models, setModels] = useState([]);
  const defaultValues = {
    city: [],
    make: "",
    model: "",
    modelTrim: "",
    bodyType: [],
    price: {
      min: "",
      max: "",
    },
    brandNew: false,
  };
  const [filterData, setFilterData] = useState({
    ...defaultValues,
    ...filters,
  });

  useEffect(() => {
    dispatch(fromDetail());
  }, [dispatch]);

  if (error) {
    toast.error(error);
  }

  const [selectedFilters, setSelectedFilters] = useState([]);
  const filtersRef = useRef(filterData);

  useEffect(() => {
    setModels([]);
    if (filterData.make) {
      getModels({
        makeId: filterData.make,
        live: true,
        ownerId: "",
        page: page,
        filters: filterData,
      }).then((res) => {
        res = res?.map((v) => ({ label: v, value: v }));
        setModels(res);
      });
    }
  }, [filterData]);

  useEffect(() => {
    console.log(filterData);
  }, [filterData]);

  const resetFilters = () => {
    setFilterData({ ...defaultValues, ...filters });
    setModels([]);
  };

  const [adFiltersList, setAdFiltersList] = useState([]);

  const getFilters = async () => {
    const keys = ["cities", "modelTrim", "makes"];
    const selected = getSelectedFilters(
      selectedFilters,
      setSelectedFilters,
      filterData,
      filtersRef
    );
    keys.forEach(async (key) => {
      let response = await getAdFiltersList1(
        page,
        "",
        filterData,
        selected,
        key
      );
      setAdFiltersList((adFiltersList) => ({
        ...adFiltersList,
        ...getAllFiltersData1(response),
      }));
    });
  };

  useEffect(() => {
    getFilters();
  }, [filterData]);

  return (
    <section
      class="banner"
      style={{
        backgroundImage: `url(${
          bannerBuy ? bannerBuy : "/assets/images/bannerhome.jpg"
        })`,
      }}
    >
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="setform account-card" style={{ overflow: "unset" }}>
              <ul
                class="nav nav-tabs d-flex justify-content-center align-items-center usedNewTabs w-100 m-0 mb-3"
                id="myTab"
                role="tablist"
              >
                <ListItem
                  key={1}
                  style={"nav-item w-50"}
                  inlineStyle={{
                    marginBottom: "0px",
                    padding:
                      i18n.language === "English"
                        ? "0px 12px 0px 0px"
                        : "0px 0px 0px 12px",
                  }}
                  innerhtmlType={"modalButton"}
                  listClick={(e) => {
                    setFilterData({ ...defaultValues, brandNew: false });
                    setSelectedFilters([]);
                    setToggle("used");
                  }}
                  innerData={{
                    class: `nav-link p-0 border-0 active`,
                    id: "tab1-tab",
                    toggle: "tab",
                    target: "#tab1",
                    type: "button",
                    role: "tab",
                    controls: "tab1",
                    selected: "true",
                    title: (
                      <>
                        <div
                          className={`${
                            toggle === "used" ? "selected" : ""
                          } tab-label`}
                        >
                          {t("Used cars")}
                        </div>
                        <div className="svg-icon">
                          <svg
                            className="used"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 283.46 283.46"
                            fill={toggle === "used" ? "#4c7ee8" : "#606871"}
                          >
                            <path d="M59.55,118.01c-3.4-.66-6.44-1.12-9.41-1.87-1.63-.41-3.25-1.11-4.68-1.99-5-3.07-5.13-9.35-.35-12.74,6.67-4.73,18.05-3.04,23.62,3.67.49-1.05.92-2.01,1.37-2.95,1.92-3.98,3.59-8.1,5.82-11.9,5.72-9.75,14.1-15.49,25.55-16.89,24.53-3,49.07-2.93,73.63-.84,3.55.3,7.09.85,10.59,1.5,10.86,2.03,18.02,8.87,23.04,18.25,2.19,4.08,3.99,8.38,5.98,12.59,1.36-1.28,2.53-2.94,4.13-3.77,6.25-3.27,12.69-3.21,18.96,0,2.65,1.35,4.16,3.71,4.02,6.83-.14,3.18-1.78,5.63-4.63,6.7-3.45,1.28-7.12,1.97-10.71,2.87-.72.18-1.5.12-2.23.17,0,.28-.06.5,0,.56,6.7,6.14,8.77,14.28,9.61,22.82.58,5.93.83,11.92.88,17.88.12,15.44.04,30.89.03,46.33,0,4.96-2.3,7.22-7.28,7.23-6.52,0-13.04,0-19.56,0-4.61,0-6.96-2.39-6.97-7.05,0-2.39,0-4.78,0-7.32h-118.43c0,2.62.02,5.16,0,7.69-.05,4.18-2.5,6.65-6.67,6.67-6.83.03-13.66.03-20.49,0-4.21-.02-6.64-2.43-6.64-6.67,0-17.93-.08-35.85.1-53.78.05-5.1.63-10.23,1.39-15.27,1.08-7.1,3.52-13.67,9.32-18.72ZM75.95,114.64c44.01-3.18,87.66-3.16,131.66,0-3.06-7.68-5.65-15.09-10.14-21.57-3.58-5.17-8.43-8.6-14.85-9.44-2.54-.33-5.06-.77-7.61-1-23.47-2.17-46.9-2.06-70.37.37-10.2,1.05-17.24,5.91-21.57,14.97-1.97,4.12-3.74,8.34-5.57,12.53-.54,1.25-.97,2.55-1.56,4.14ZM140,165.82c8.92-.49,16.29-.82,23.63-1.35,3.16-.23,6.32-.73,9.41-1.4,2.51-.54,4.19-2.19,4.85-4.81.62-2.48,1.5-4.89,2.09-7.38,1.58-6.57-.05-8.81-6.8-9.58-.08,0-.15-.01-.23-.02-14.45-1.56-28.94-2.2-43.45-1.41-7.19.4-14.38,1.06-21.54,1.89-4.01.47-5.52,2.68-4.89,6.68.44,2.74,1.49,5.38,2,8.11.86,4.6,3.73,6.79,8.17,7.16,9.42.78,18.85,1.49,26.76,2.11ZM142,175.69h0c-7.83,0-15.67,0-23.5.02-2.91,0-3.86,1-3.91,3.92-.02,1.24,0,2.48,0,3.72.03,3.47.92,4.36,4.45,4.36,14.12,0,28.23,0,42.35,0,1.4,0,2.79.02,4.19-.04,2.12-.09,3.29-1.17,3.31-3.36.01-1.24.02-2.48.02-3.72,0-4.21-.69-4.9-4.81-4.9-7.37,0-14.74,0-22.11,0ZM188.52,160.2c3.28-.26,6.12-.43,8.95-.73,5.7-.59,11.47-.87,17.08-1.97,6.78-1.34,10-5.95,9.52-12.79-.17-2.43-1-4.82-1.56-7.23-.55-2.37-1.95-3.04-4.23-2.16-1.07.41-2.25.56-3.38.82-4.83,1.1-9.68,2.15-14.5,3.32-3.16.77-6.31,1.92-7.43,5.3-1.63,4.91-2.88,9.94-4.44,15.43ZM94.95,160.2c-1.28-4.6-2.63-8.8-3.59-13.08-.95-4.27-3.65-6.53-7.64-7.49-6.63-1.58-13.28-3.1-19.94-4.52-.62-.13-1.78.43-2.08.99-2.03,3.8-2.68,7.87-2.09,12.16.48,3.5,2.22,6.17,5.35,7.68,2.06.99,4.33,1.8,6.59,2.1,5.06.69,10.18,1.02,15.27,1.48,2.6.23,5.2.43,8.14.68Z" />
                          </svg>
                        </div>
                      </>
                    ),
                  }}
                />
                <ListItem
                  key={2}
                  style={"nav-item w-50"}
                  inlineStyle={{
                    marginBottom: "0px",
                    padding:
                      i18n.language === "English"
                        ? "0px 0px 0px 12px"
                        : "0px 12px 0px 0px",
                  }}
                  innerhtmlType={"modalButton"}
                  listClick={(e) => {
                    setFilterData({ ...defaultValues, brandNew: true });
                    setSelectedFilters([]);
                    setToggle("new");
                  }}
                  innerData={{
                    class: `nav-link p-0 border-0`,
                    id: "tab2-tab",
                    toggle: "tab",
                    target: "#tab2",
                    type: "button",
                    role: "tab",
                    controls: "tab2",
                    selected: "false",
                    title: (
                      <>
                        <div
                          className={`${
                            toggle === "new" ? "selected" : ""
                          } tab-label`}
                        >
                          {t("New cars")}
                        </div>
                        <div className="svg-icon">
                          <svg
                            className="new"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 283.46 283.46"
                            fill={toggle === "new" ? "#4c7ee8" : "#606871"}
                          >
                            <path d="M244.93,90.84c-27.18,3.01-49.46,10.92-53.3,44.46-3.86-33.17-25.7-41.54-52.97-44.32,26.09-4.06,49.26-11.04,52.54-44.43,4.47,32.39,26.67,41.08,53.73,44.29Z" />
                            <path d="M231.66,183.34c-.07-9.82.33-11.95-.88-17.88-.9-4.45-3.13-14.8-10.86-20.74-2.57-1.98-5.48-3.26-5.74-3.37-3.9-1.7-7.41-2.14-9.67-2.26-24.21-1.75-50.3-2.66-78.02-2.3-17.85.24-35.72,1-53.64,2.3.6-1.6,1.02-2.9,1.56-4.14,1.83-4.19,3.6-8.41,5.57-12.53,4.33-9.06,11.37-13.92,21.57-14.97,9.22-.95,18.43-1.53,27.65-1.76v-10.12c-10.27.26-20.55.97-30.81,2.23-11.45,1.4-19.83,7.14-25.55,16.89-2.23,3.8-3.9,7.92-5.82,11.9-.46.95-.89,1.91-1.37,2.95-5.57-6.72-16.95-8.41-23.62-3.67-4.78,3.39-4.65,9.67.35,12.74,1.43.88,3.05,1.58,4.68,1.99,2.97.74,6,1.21,9.41,1.87-5.8,5.04-8.24,11.62-9.32,18.72-.77,5.05-1.34,10.18-1.39,15.27-.18,17.92-.11,35.85-.1,53.78,0,4.23,2.43,6.65,6.64,6.67,6.83.03,13.66.03,20.49,0,4.17-.02,6.62-2.49,6.67-6.67.03-2.54,0-5.07,0-7.69h118.43c0,2.54,0,4.93,0,7.32.02,4.66,2.37,7.05,6.97,7.05,6.52,0,13.04,0,19.56,0,4.97,0,7.27-2.26,7.28-7.23.02-15.44.09-30.89-.03-46.33ZM83.72,183.96c-5.1-.46-10.21-.79-15.27-1.48-2.26-.31-4.53-1.11-6.59-2.1-3.13-1.51-4.87-4.17-5.35-7.68-.59-4.29.06-8.36,2.09-12.16.3-.56,1.47-1.13,2.08-.99,6.67,1.42,13.31,2.93,19.94,4.52,4,.95,6.69,3.21,7.64,7.49.95,4.28,2.31,8.48,3.59,13.08-2.94-.24-5.54-.44-8.14-.68ZM165.81,208.76c-.02,2.19-1.19,3.27-3.31,3.36-1.39.06-2.79.04-4.19.04-14.12,0-28.23,0-42.35,0-3.53,0-4.42-.89-4.45-4.36-.01-1.24-.02-2.48,0-3.72.04-2.92,1-3.92,3.91-3.92,7.83-.02,15.67,0,23.5,0h0c7.37,0,14.74-.01,22.11,0,4.12,0,4.8.69,4.81,4.9,0,1.24,0,2.48-.02,3.72ZM176.9,175.34c-.6,2.48-1.47,4.9-2.09,7.38-.66,2.62-2.34,4.27-4.85,4.81-3.1.67-6.26,1.17-9.41,1.4-7.35.53-14.71.85-23.63,1.35-7.91-.62-17.33-1.33-26.76-2.11-4.45-.37-7.31-2.55-8.17-7.16-.51-2.73-1.57-5.37-2-8.11-.64-4,.88-6.21,4.89-6.68,7.16-.83,14.35-1.49,21.54-1.89,14.52-.8,29-.16,43.45,1.41.08,0,.15.01.23.02,6.76.77,8.38,3.01,6.8,9.58ZM211.46,181.94c-5.6,1.11-11.37,1.38-17.08,1.97-2.83.29-5.68.47-8.95.73,1.56-5.49,2.81-10.53,4.44-15.43,1.12-3.39,4.27-4.53,7.43-5.3,4.82-1.17,9.67-2.22,14.5-3.32,1.13-.26,2.31-.4,3.38-.82,2.28-.88,3.68-.22,4.23,2.16.56,2.4,1.38,4.79,1.56,7.23.49,6.84-2.74,11.45-9.52,12.79Z" />
                          </svg>
                        </div>
                      </>
                    ),
                  }}
                />
              </ul>
              <div class="tab-content" id="myTabContent">
                <FirstForm
                  data={detail}
                  carTypes={carTypes}
                  models={models}
                  filterData={filterData}
                  setFilterData={setFilterData}
                  resetFilters={resetFilters}
                  adFiltersList={adFiltersList}
                />
                <SecondForm
                  data={detail}
                  carTypes={carTypes}
                  models={models}
                  filterData={filterData}
                  setFilterData={setFilterData}
                  resetFilters={resetFilters}
                  adFiltersList={adFiltersList}
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            {/* <h2 style={{ textShadow: "1px 1px 5px gray" }} className="">
              {t("Find your perfect car")}
            </h2> */}
          </div>
        </div>
      </div>
    </section>
  );
}
